import { Box, Typography } from '@mui/material'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { lightBlue } from 'src/utils/colors'

interface propTypes {
  title: string
  links: {
    icon?: any
    text: string
    plainText?: boolean
    aHref?: boolean
    path?: string
  }[]
}
const FooterLink: React.FC<propTypes> = (props) => {
  const { title, links } = props
  const location = useLocation()
  return (
    <Box
      sx={{
        borderBottom: `1.5px solid ${lightBlue}`,
        pb: { xs: 0, md: 1 },
        mb: { xs: 4, md: 0 },
      }}
    >
      <Typography variant="h6" color="primary" sx={{ mb: { xs: 1, md: 2 } }}>
        {title}:
      </Typography>
      {links.map(
        (link, index) =>
          link.path !== location.pathname && (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                mr: 4,
                my: 1,
                fontSize: 'larger',
                transition: 'all 0.2s',
                ':hover': {
                  transform: 'scale3d(1.1, 1.1, 1.1)',
                },
              }}
            >
              {link.icon && (
                <Box
                  sx={{
                    '> .MuiSvgIcon-root': {
                      fontSize: '35px',
                      mr: 0.5,
                      display: 'flex',
                      fill: lightBlue,
                    },
                  }}
                >
                  {link.icon}
                </Box>
              )}
              {link.plainText ? (
                <Typography
                  sx={{
                    color: lightBlue,
                    fontSize: '19.2px',
                  }}
                >
                  {link.text}
                </Typography>
              ) : link.aHref ? (
                <a
                  href={link.path}
                  style={{
                    textDecoration: 'none',
                    color: lightBlue,
                  }}
                  rel="noreferrer"
                  target="_blank"
                >
                  {link.text}
                </a>
              ) : (
                <Link
                  to={link.path ? link.path : ''}
                  style={{ textDecoration: 'none', color: lightBlue }}
                >
                  {link.text}
                </Link>
              )}
            </Box>
          )
      )}
    </Box>
  )
}

export default FooterLink
